export default __webpack_public_path__ + "static/media/state-detail.18352324.svg";